import { Link } from "react-router-dom";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface LinkedProductOption {
  id: string;
  title: string;
  type?: string | null;
}

interface LinkedProductFieldProps {
  /** true uniquement pour le propriétaire ayant le rôle pro ou admin */
  canLinkProduct: boolean;
  products: LinkedProductOption[];
  selectedProductId: string | null;
  onChange: (productId: string | null) => void;
  /** Permet de fermer une modale avant la navigation vers /pro-application */
  onNavigateAway?: () => void;
}

/**
 * Champ « Produit lié » : interactif pour pro/admin, visible mais inerte
 * pour les autres rôles avec une invitation à ouvrir leur boutique.
 */
const LinkedProductField = ({
  canLinkProduct,
  products,
  selectedProductId,
  onChange,
  onNavigateAway,
}: LinkedProductFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="product">Produit lié (optionnel)</Label>
      <Select
        value={selectedProductId || "none"}
        onValueChange={(value) => onChange(value === "none" ? null : value)}
        disabled={!canLinkProduct || products.length === 0}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Aucun — pas de bouton d'achat" />
        </SelectTrigger>
        <SelectContent className="z-50 bg-background">
          <SelectItem value="none">Aucun — pas de bouton d'achat</SelectItem>
          {products.map((product) => (
            <SelectItem key={product.id} value={product.id}>
              {product.title}
              {product.type ? ` (${product.type})` : ""}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {canLinkProduct ? (
        <p className="text-xs text-muted-foreground">
          {products.length === 0
            ? "Aucun produit actif. Créez un produit dans votre boutique pour l'associer à une vidéo."
            : "Associez cette vidéo à l'un de vos produits pour le promouvoir"}
        </p>
      ) : (
        <p className="text-xs text-muted-foreground">
          Réservé aux comptes Pro. Ouvrez votre boutique pour lier un produit à vos vidéos.{" "}
          <Link
            to="/pro-application"
            onClick={onNavigateAway}
            className="text-primary underline underline-offset-2"
          >
            Passer Pro
          </Link>
        </p>
      )}
    </div>
  );
};

export default LinkedProductField;
